import React from 'react';
import PropTypes from 'prop-types';
import SectionBadge from '../SectionBadge';
import CtaButton from '../CtaButton';
import * as Styles from './Calendar.styles';
import calendarChatImg from '../../media/calendar-chat.png';
import useSupergatorSso from '@/hooks/useSupergatorSso';

const Calendar = ({ locale }) => {
  const { redirectToSupergator, loading } = useSupergatorSso();

  return (
    <Styles.Wrapper>
      <Styles.LeftSide>
        <Styles.BadgeWrapper>
          <SectionBadge text={locale.badge} />
        </Styles.BadgeWrapper>

        <Styles.TitleWrapper>
          <Styles.Title>
            {locale.title}
          </Styles.Title>
        </Styles.TitleWrapper>

        <Styles.DescriptionWrapper>
          <Styles.Description>{locale.description}</Styles.Description>
        </Styles.DescriptionWrapper>

        <CtaButton onClick={redirectToSupergator} disabled={loading}>
          {locale.cta}
        </CtaButton>
      </Styles.LeftSide>

      <Styles.RightSide>
        <Styles.CalendarImage
          src={calendarChatImg}
          alt={locale.imageAlt}
        />
      </Styles.RightSide>
    </Styles.Wrapper>
  );
};

Calendar.propTypes = {
  locale: PropTypes.shape({
    badge: PropTypes.string,
    titleGradient: PropTypes.string,
    titleNormal: PropTypes.string,
    description: PropTypes.string,
    cta: PropTypes.string,
    imageAlt: PropTypes.string,
  }).isRequired,
};

export default Calendar;
